"use strict";
exports.__esModule = true;
exports.checkEmailStrict = exports.checkEmail = void 0;
var opaque_types_1 = require("@shef/opaque-types");
var Either_1 = require("fp-ts/Either");
var GENERIC_INVALID_EMAIL_MESSAGE = 'Please enter a valid email address';
var RE_VALID_EMAIL_RFC_5322 = 
// eslint-disable-next-line no-control-regex
/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
// This one is the same as above but includes the start/end delimiters (^ and $) to ensure that the ENTIRE email string is valid
var STRICT_EMAIL_REGEX = 
// eslint-disable-next-line no-control-regex
/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
var checkEmail = function (email) {
    var sanitized = email === null || email === void 0 ? void 0 : email.trim();
    if (!sanitized) {
        return (0, Either_1.left)("Please enter an email address");
    }
    var valid = RE_VALID_EMAIL_RFC_5322.test(sanitized);
    if (!valid) {
        return (0, Either_1.left)(GENERIC_INVALID_EMAIL_MESSAGE);
    }
    return (0, Either_1.right)((0, opaque_types_1.makeOpaque)(sanitized));
};
exports.checkEmail = checkEmail;
var checkEmailStrict = function (email) {
    var rfc5322Check = (0, exports.checkEmail)(email);
    if ((0, Either_1.isLeft)(rfc5322Check)) {
        return rfc5322Check;
    }
    var strictRegex = STRICT_EMAIL_REGEX.test(rfc5322Check.right);
    if (!strictRegex) {
        return (0, Either_1.left)(GENERIC_INVALID_EMAIL_MESSAGE);
    }
    var _a = rfc5322Check.right.split('@'), localPart = _a[0], domain = _a[1];
    if (!localPart || !domain) {
        return (0, Either_1.left)(GENERIC_INVALID_EMAIL_MESSAGE);
    }
    var lowerDomain = domain === null || domain === void 0 ? void 0 : domain.toLowerCase();
    if (lowerDomain === 'gmail.com' || lowerDomain === 'googlemail.com') {
        /**
         * Gmail rules:
         * - only allows letters (not even accented letters), numbers, or periods.
         * - the period must not be at the beginning or end of the string.
         * - there cannot be consecutive periods
         * - the username must be between 6 and 30 characters
         *
         * note that this regex does not allow + signs, which are technically valid, but are ignored by gmail
         *  */
        if (!/^[a-zA-Z0-9](\.?[a-zA-Z0-9]){5,29}$/.test(localPart)) {
            return (0, Either_1.left)(GENERIC_INVALID_EMAIL_MESSAGE);
        }
    }
    return rfc5322Check;
};
exports.checkEmailStrict = checkEmailStrict;
//# sourceMappingURL=checkEmail.js.map